
<template>
  <div class="header" :class="scrollTop > scrollNum ? 'header_bg' : ''">
    <div class="header_main">
      <div class="header_logo">
        <img
          v-if="scrollTop > scrollNum"
          src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933680089/logo_blank.png"
        />
        <img
          v-else
          src="https://zhongzhiyuan.oss-cn-chengdu.aliyuncs.com/files/2025/3/14/1741933747160/logo_white.png"
          alt=""
        />
      </div>
      <div class="header_tab">
        <div
          class="tab_item"
          :class="tabIndex == index ? 'tab_item_active' : ''"
          v-for="(item, index) in navItems"
          @click="handleOpen(item)"
          :key="index"
        >
          <router-link :to="item.path">{{ item.label }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, watch, watchEffect } from "vue";

import { useRouter } from "vue-router";

import {
  defineComponent,
  toRefs,
  reactive,
  getCurrentInstance,
  onMounted,
} from "vue";

export default defineComponent({
  props: {
    scrollTop: Number,
  },
  setup(props) {
    const { proxy } = getCurrentInstance() as any;
    const router = useRouter();
    const state = reactive({
      scrollTop: ref(props.scrollTop) as any,
      tabIndex: 0,
      scrollNum: 550,
      navItems: [
        { label: "首页", path: "/" },
        { label: "核心业务", path: "/core" },
        { label: "工程业绩", path: "/project" },
        { label: "新闻资讯", path: "/news" },
        { label: "企业文化", path: "/culture" },
        { label: "项目管理系统", path: "/" },
      ],
    });
    onMounted(() => {
      getTabIndex();
    });
    const getTabIndex = () => {
      proxy.$emit("updateScrollTop", 0);
      if (router.currentRoute.value.path === "/") {
        state.tabIndex = 0;
        state.scrollNum = 550;
      } else if (router.currentRoute.value.path === "/core") {
        state.tabIndex = 1;
        state.scrollNum = 352;
      } else if (router.currentRoute.value.path === "/project") {
        state.tabIndex = 2;
        state.scrollNum = 352;
      }  else if (router.currentRoute.value.path === "/projectInfo") {
        state.tabIndex = 2;
        state.scrollNum = 152;
      }else if (router.currentRoute.value.path === "/news") {
        state.tabIndex = 3;
        state.scrollNum = 352;
      } else if (router.currentRoute.value.path === "/culture") {
        state.tabIndex = 4;
        state.scrollNum = 352;
      }
    };
    const handleOpen = (item: any) => {
      if (item.label == "项目管理系统") {
        window.open("http://xt.zzydy.cn/", "_blank", "noopener noreferrer");
      }
    };
    watch(
      () => props.scrollTop, // 监听源
      (newValue) => {
        state.scrollTop = newValue; // 更新逻辑
      }
    );
    watchEffect(() => {
      getTabIndex();
    });
    return {
      handleOpen,
      ...toRefs(state),
    };
  },
});
</script>

<style scoped lang="scss">
.header {
  position: sticky;
  top: 0;
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  z-index: 999;
  margin-top: -74px;
  .header_main {
    height: 74px;
    width: 1600px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .header_logo {
      img {
        width: 152px;
        height: 42px;
      }
    }
    .header_tab {
      display: flex;
      height: 74px;
      .tab_item {
        a {
          line-height: 74px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          text-decoration: none;
        }
        margin-left: 48px;
      }
      .tab_item_active {
        border-bottom: 2px solid #ffffff;
        a {
          color: #ffffff;
        }
      }
    }
  }
}
.header_bg {
  background: #ffffff;
  .header_main {
    .header_tab {
      .tab_item {
        a {
          font-size: 14px;
          color: #000000;
        }
      }
      .tab_item_active {
        border-bottom: 2px solid #377dca;
        a {
          color: #377dca;
        }
      }
    }
  }
}
</style>
